export type RemoteAudioChannelOptions = {
  audioElement?: HTMLAudioElement;
};

export class RemoteAudioChannel {
  private audioElement: HTMLAudioElement | null;
  private selectedSinkId: string | null = null;

  constructor({ audioElement }: RemoteAudioChannelOptions = {}) {
    this.audioElement = audioElement ?? null;
  }

  public attachStream(stream: MediaStream, elOverride?: HTMLAudioElement): void {
    if (elOverride) {
      this.audioElement = elOverride;
    }

    if (!this.audioElement) {
      this.audioElement = document.createElement('audio');
      this.audioElement.autoplay = true;
      this.audioElement.style.display = 'none';
      document.body.appendChild(this.audioElement);
    }

    this.audioElement.srcObject = stream;
    
    // Apply selected speaker if set
    if (this.selectedSinkId && 'setSinkId' in this.audioElement) {
      this.setSinkId(this.selectedSinkId);
    }
  }
  
  public async setSinkId(sinkId: string): Promise<void> {
    this.selectedSinkId = sinkId;
    
    if (this.audioElement && 'setSinkId' in this.audioElement) {
      try {
        await (this.audioElement as any).setSinkId(sinkId);
      } catch (error) {
        console.error('Error setting audio output device:', error);
      }
    }
  }

  public cleanup(): void {
    if (!this.audioElement) return;

    this.audioElement.pause();
    this.audioElement.srcObject = null;
    this.audioElement.remove();
    this.audioElement = null;
  }
} 